import clsx from "clsx";
import TransactionsChart from "ui/transaction/container/TransactionsChart/TransactionsChart";
import UsersChart from "ui/user/containers/UsersChart/UsersChart";
import { MainStatsChartsRoot } from "./MainStatsCharts.styles";
import { MainStatsChartsProps } from "./MainStatsCharts.types";

function MainStatsCharts({ className, ...rest }: MainStatsChartsProps) {
    return (
        <MainStatsChartsRoot className={clsx("main-stats-charts", className)} {...rest}>
            <UsersChart css={{ width: "100%" }} color="primary" />
            <TransactionsChart css={{ width: "100%" }} color="red" />
        </MainStatsChartsRoot>
    );
}

export default MainStatsCharts;
